"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = require("./events");
function matches(el, selector) {
    var proto = Element.prototype;
    var fn = proto.matches
        || proto.webkitMatchesSelector
        || proto.mozMatchesSelector
        || proto.msMatchesSelector;
    return fn.call(el, selector);
}
exports.startDOMListeners = function (sendEvent, root) {
    return root.addEventListener('click', function (e) {
        if (!matches(e.target, '[data-findify-track]'))
            return;
        var _a = events_1.getEventData(e.target), track = _a.track, props = __rest(_a, ["track"]);
        sendEvent(track, props);
    }, false);
};
//# sourceMappingURL=dom.js.map